

<div class="modal-body">
    <div #agenda class="row">
        <div class="col-md-12 col-sm-12">
            <div class="form-group">
                <angular-editor id="editor1" [(ngModel)]="addUserObj.text" [config]="config"></angular-editor>
            </div>
        </div>
    </div>   
    <button *ngIf="addUserObj.text" type="button " class="btn btn-sm btn-default mr-2 command-edit float-right"
    (click)="copy()">
    <em class="fas fa-copy fa-fw"></em>
</button>
</div>
<div class="modal-footer">
 
</div>